import { Component } from '@angular/core';
import { UserService } from '../../services/user.service';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { AppError, AuthService, ConfigurationService } from 'shared';
import { Observable } from 'rxjs';
import { map, first } from 'rxjs/operators';
import { IUser, UserType } from 'projects/customerportal/src/app/interfaces/user';
import { AlarmService } from '../../services/alarm.service';
import { PageInfoService } from '../../services/page-info.service';
import { AccessClaim } from 'projects/shared/src/lib/interfaces/access';
import { TopbarComponent } from '../../../../../shared/src/lib/components/topbar/topbar.component';
import { TopbarDropdownComponent } from '../../../../../shared/src/lib/components/topbar-dropdown/topbar-dropdown.component';
import { AsyncPipe } from '@angular/common';
import { TopbarDropdownItemComponent } from '../../../../../shared/src/lib/components/topbar-dropdown-item/topbar-dropdown-item.component';
import { Angulartics2OnModule } from 'angulartics2';
import { PageSpinnerComponent } from '../../../../../shared/src/lib/components/page-spinner/page-spinner.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-root-page',
    templateUrl: './root-page.component.html',
    styleUrls: ['./root-page.component.scss'],
    imports: [TopbarComponent, TopbarDropdownComponent, TopbarDropdownItemComponent, Angulartics2OnModule, RouterLink, PageSpinnerComponent, RouterOutlet, TranslateModule, AsyncPipe]
})
export class RootPageComponent {
  public userName$: Observable<string>;
  public accountAvailable$: Observable<boolean>;
  public userManagementAvailable$: Observable<boolean>;
  public pageError$: Observable<AppError>;
  public currentLanguage$: Observable<string>;
  public currentUser$: Observable<IUser | null>;

  constructor(
    private authService: AuthService,
    private alarmService: AlarmService,
    public userService: UserService,
    public router: Router,
    public configurationService: ConfigurationService,
    public pageInfoService: PageInfoService,
  ) {
    this.userName$ = userService.currentUser$.pipe(
        first(),
        map(user => user?.name || '')
    );
    this.accountAvailable$ = userService.currentUser$.pipe(
        first(),
        map(user => user?.type === UserType.BuildingConnect)
    );
    this.userManagementAvailable$ = this.userService.hasClaim(AccessClaim.CustomerPortalUserManagement);

    this.currentUser$ = this.userService.currentUser$.pipe(first());
  }

  navigateToRoot() {
    this.router.navigate(['/facilities'], {queryParamsHandling: 'merge', queryParams: this.pageInfoService.mapQueryParams});
  }

  public signin() {
    this.authService.signinRedirect('/');
  }

  logout(): void {
    this.authService.signout();
  }

  renewCookies(): void {
    if (typeof Cookiebot !== 'undefined') {
      Cookiebot.renew();
    }
  }

}
